import React, { Component } from 'react';
import { Spin, message } from 'antd';
import Title from '../Components/Title';
import Text from '../../../../basicElement/Text';
import compareFn from '../../Components/compareFn';
import TableC from '../../../../basicElement/TableC';
import EditableCell from '../../../../basicElement/EditableCell';
import Fetch from '../../../../../common/Fetch';
import API_URL from '../../../../../common/url';
import format from '../../../../shared/format';

class Heredity extends Component {
    state = {
        data: [
            { name: '牵头单位医院材料准备',  siteNo: '20', period: '42', editable: true },
            { name: '其他中心医院材料准备',  siteNo: '20', period: '42' },
            { name: '小计' },
        ],
        prevData: [],
        loading: false,
        canEdit: false,
    }

    componentDidMount() {
        const { editable } = this.props;
        this.setState({ canEdit: editable });
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.editable && this.props.editable) {
            this.setState({ canEdit: true });
        }
    }

    loadData = () => {
        this.setState({ loading: true });
        Fetch.post(API_URL.site.queryInvestigationSiteFee)
        .then(res => {
            const { datas, totalCount } = res;
            pagination.total = totalCount;
            this.setState({
                pagination,
                data: datas,
                loading: false,
            });
        })
        .catch(error => {
            console.log(error);
            this.setState({ loading: false });
        });
    }
    
    getColumns = () => {
        const { names, mode } = this.props;
        const { data, prevData, canEdit } = this.state;
        const len = data.length;
        const columns = [{
            title: '',
            dataIndex: 'name',
            key: 'name',
            width: 210,
            render: (text, record, index) => {
                if (index < len - 1) {
                    return text;
                } else {
                    return <strong>{text}</strong>;
                }
            }
        }, {
            title: names.role,
            dataIndex: 'role',
            key: 'role',
            width: 130,
        }, {
            title: <Text asterisk={canEdit}>{names.price}<br/>{names.cs}</Text>,
            dataIndex: 'price',
            key: 'price',
            width: 150,
            render: (text, record, index) => {
                if (index !== len - 1) {
                    if (mode === 'compare') {
                        return compareFn(prevData, data, 'price');
                    } else {
                        return (
                            <div className="inlineBlock">
                                <EditableCell type="Number" editable={canEdit} value={text} config={{precision: 2}} placeholder={names.inputPlaceholder} onChange={value => this.handleChange(value, index, 'price')} />
                            </div>
                        );
                    }
                }
            }
        }, {
            title: <Text asterisk={canEdit}>{names.siteNo}</Text>,
            dataIndex: 'siteNo',
            key: 'siteNo',
            width: 130,
            render: (text, record, index) => {
                const { editable } = record;
                if (index !== len - 1) {
                    if (mode === 'compare') {
                        return compareFn(prevData, data, 'siteNo');
                    } else {
                        return (
                            <div className="inlineBlock">
                                <EditableCell type="Number" editable={canEdit && editable} value={text} placeholder={names.inputPlaceholder} onChange={value => this.handleChange(value, index, 'siteNo')} />
                            </div>
                        );
                    }
                }
            }
        }, {
            title: names.cost,
            dataIndex: 'cost',
            key: 'cost',
            width: 150,
            render: (text, record, index) => {
                if (index === len - 1) {
                    let total = 0;
                    data.forEach((item, index) => {
                        if (index < len - 1) {
                            total += (item.cost || 0) * 1;
                        }
                    });
                    return format('money', total);
                } else {
                    return <strong>{format('money', text)}</strong>;
                }
            }
        }, {
            title: names.otherRemarks,
            dataIndex: 'otherRemarks',
            key: 'otherRemarks',
            render: (text, record, index) => {
                if (mode === 'compare') {
                    return compareFn(prevData, data, 'otherRemarks');
                } else {
                    return (
                        <div className="inlineBlock">
                            <EditableCell type="Input" editable={canEdit} value={text} placeholder={names.inputPlaceholder} onChange={value => this.handleChange(value, index, 'otherRemarks')} />
                        </div>
                    );
                }
            }
        }];
        return columns;
    }

    handleChange = (value, index, key) => {
        const { data } = this.state;
        const target = data[index];
        target[key] = value;
        if (key === 'price') {
            const { price, siteNo } = target;
            if (siteNo || siteNo === 0) {
                target.cost = (price || 0) * siteNo ;
            }
        } else if (key === 'siteNo') {
            const { price, siteNo } = target;
            if (price || price === 0) {
                target.cost = (siteNo || 0) * price ;
            }
        }
        this.setState({ data: [...data] });
    }

    save = (canEdit) => {
        if (!canEdit) {
            this.setState({ canEdit: true });
        } else {
            const { names } = this.props;
            const { data } = this.state;
            for (let i = 0; i < data.length - 1; i++) {
                const item = data[i];
                if (!item.price && item.price !== 0) {
                    message.warning(`${names.inputPlaceholder}${names.price} ${names.cs}!`);
                    return;
                } else if (!item.siteNo && item.siteNo !== 0) {
                    message.warning(`${names.inputPlaceholder}${names.siteNo}!`);
                    return;
                }
            }
            this.setState({ canEdit: false });
            // this.props.hasChange(false);
        }
    }

    render() {
        const { title, editable } = this.props;
        const { data, loading, canEdit } = this.state;
        return (
            <Spin spinning={loading}>
                <Title title={title} editable={editable} canEdit={canEdit} save={this.save} />
                <div style={{ paddingLeft: 10 }}>
                    <TableC
                        data={data}
                        columns={this.getColumns()}
                        className="quotation_heredity"
                    />
                </div>
            </Spin>
        );
    }
}

export default Heredity;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Detail/Table/Heredity.js